// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file forms/v1/form_submission.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Field, FieldJson } from "./field_pb";
import { file_forms_v1_field } from "./field_pb";
import type { DateRange, DateRangeJson, PaginationOptions, PaginationOptionsJson } from "./options_pb";
import { file_forms_v1_options } from "./options_pb";
import type { SuccessAction, SuccessActionJson } from "./success_screen_pb";
import { file_forms_v1_success_screen } from "./success_screen_pb";
import type { Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file forms/v1/form_submission.proto.
 */
export const file_forms_v1_form_submission: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_forms_v1_field, file_forms_v1_options, file_forms_v1_success_screen, file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * @generated from message forms.v1.TextAnswer
 */
export type TextAnswer = Message<"forms.v1.TextAnswer"> & {
	/**
	 * @generated from field: string value = 1;
	 */
	value: string;
};

/**
 * @generated from message forms.v1.TextAnswer
 */
export type TextAnswerJson = {
	/**
	 * @generated from field: string value = 1;
	 */
	value?: string;
};

/**
 * Describes the message forms.v1.TextAnswer.
 * Use `create(TextAnswerSchema)` to create a new message.
 */
export const TextAnswerSchema: GenMessage<TextAnswer, { jsonType: TextAnswerJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 0);

/**
 * @generated from message forms.v1.TextAnswers
 */
export type TextAnswers = Message<"forms.v1.TextAnswers"> & {
	/**
	 * @generated from field: repeated forms.v1.TextAnswer values = 1;
	 */
	values: TextAnswer[];
};

/**
 * @generated from message forms.v1.TextAnswers
 */
export type TextAnswersJson = {
	/**
	 * @generated from field: repeated forms.v1.TextAnswer values = 1;
	 */
	values?: TextAnswerJson[];
};

/**
 * Describes the message forms.v1.TextAnswers.
 * Use `create(TextAnswersSchema)` to create a new message.
 */
export const TextAnswersSchema: GenMessage<TextAnswers, { jsonType: TextAnswersJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 1);

/**
 * @generated from message forms.v1.FileAnswer
 */
export type FileAnswer = Message<"forms.v1.FileAnswer"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: string file_name = 2;
	 */
	fileName: string;

	/**
	 * @generated from field: string mimetype = 3;
	 */
	mimetype: string;
};

/**
 * @generated from message forms.v1.FileAnswer
 */
export type FileAnswerJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: string file_name = 2;
	 */
	fileName?: string;

	/**
	 * @generated from field: string mimetype = 3;
	 */
	mimetype?: string;
};

/**
 * Describes the message forms.v1.FileAnswer.
 * Use `create(FileAnswerSchema)` to create a new message.
 */
export const FileAnswerSchema: GenMessage<FileAnswer, { jsonType: FileAnswerJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 2);

/**
 * @generated from message forms.v1.FileAnswers
 */
export type FileAnswers = Message<"forms.v1.FileAnswers"> & {
	/**
	 * @generated from field: repeated forms.v1.FileAnswer files = 1;
	 */
	files: FileAnswer[];
};

/**
 * @generated from message forms.v1.FileAnswers
 */
export type FileAnswersJson = {
	/**
	 * @generated from field: repeated forms.v1.FileAnswer files = 1;
	 */
	files?: FileAnswerJson[];
};

/**
 * Describes the message forms.v1.FileAnswers.
 * Use `create(FileAnswersSchema)` to create a new message.
 */
export const FileAnswersSchema: GenMessage<FileAnswers, { jsonType: FileAnswersJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 3);

/**
 * @generated from message forms.v1.NumericAnswer
 */
export type NumericAnswer = Message<"forms.v1.NumericAnswer"> & {
	/**
	 * @generated from field: double value = 1;
	 */
	value: number;
};

/**
 * @generated from message forms.v1.NumericAnswer
 */
export type NumericAnswerJson = {
	/**
	 * @generated from field: double value = 1;
	 */
	value?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message forms.v1.NumericAnswer.
 * Use `create(NumericAnswerSchema)` to create a new message.
 */
export const NumericAnswerSchema: GenMessage<NumericAnswer, { jsonType: NumericAnswerJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 4);

/**
 * @generated from message forms.v1.AddressAnswer
 */
export type AddressAnswer = Message<"forms.v1.AddressAnswer"> & {
	/**
	 * Street number and street name
	 *
	 * @generated from field: string address_1 = 1;
	 */
	address1: string;

	/**
	 * Apartment #, suite, unit, building no, floor...
	 *
	 * @generated from field: optional string address_2 = 2;
	 */
	address2?: string | undefined;

	/**
	 * City name
	 *
	 * @generated from field: string city = 3;
	 */
	city: string;

	/**
	 * Zone/region in country. A state in the USA, a province in Canada/Japan, etc..
	 *
	 * @generated from field: string zone = 4;
	 */
	zone: string;

	/**
	 * Localized postal code
	 *
	 * @generated from field: string postal_code = 5;
	 */
	postalCode: string;

	/**
	 * Two character Country code
	 *
	 * @generated from field: string country = 6;
	 */
	country: string;
};

/**
 * @generated from message forms.v1.AddressAnswer
 */
export type AddressAnswerJson = {
	/**
	 * Street number and street name
	 *
	 * @generated from field: string address_1 = 1;
	 */
	address1?: string;

	/**
	 * Apartment #, suite, unit, building no, floor...
	 *
	 * @generated from field: optional string address_2 = 2;
	 */
	address2?: string;

	/**
	 * City name
	 *
	 * @generated from field: string city = 3;
	 */
	city?: string;

	/**
	 * Zone/region in country. A state in the USA, a province in Canada/Japan, etc..
	 *
	 * @generated from field: string zone = 4;
	 */
	zone?: string;

	/**
	 * Localized postal code
	 *
	 * @generated from field: string postal_code = 5;
	 */
	postalCode?: string;

	/**
	 * Two character Country code
	 *
	 * @generated from field: string country = 6;
	 */
	country?: string;
};

/**
 * Describes the message forms.v1.AddressAnswer.
 * Use `create(AddressAnswerSchema)` to create a new message.
 */
export const AddressAnswerSchema: GenMessage<AddressAnswer, { jsonType: AddressAnswerJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 5);

/**
 * @generated from message forms.v1.Answer
 */
export type Answer = Message<"forms.v1.Answer"> & {
	/**
	 * @generated from oneof forms.v1.Answer.answer
	 */
	answer:
		| {
				/**
				 * @generated from field: forms.v1.TextAnswers text_answer = 1;
				 */
				value: TextAnswers;
				case: "textAnswer";
		  }
		| {
				/**
				 * @generated from field: forms.v1.AddressAnswer address_answer = 2;
				 */
				value: AddressAnswer;
				case: "addressAnswer";
		  }
		| {
				/**
				 * @generated from field: forms.v1.FileAnswers file_answer = 3;
				 */
				value: FileAnswers;
				case: "fileAnswer";
		  }
		| {
				/**
				 * @generated from field: forms.v1.NumericAnswer numeric_answer = 4;
				 */
				value: NumericAnswer;
				case: "numericAnswer";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message forms.v1.Answer
 */
export type AnswerJson = {
	/**
	 * @generated from field: forms.v1.TextAnswers text_answer = 1;
	 */
	textAnswer?: TextAnswersJson;

	/**
	 * @generated from field: forms.v1.AddressAnswer address_answer = 2;
	 */
	addressAnswer?: AddressAnswerJson;

	/**
	 * @generated from field: forms.v1.FileAnswers file_answer = 3;
	 */
	fileAnswer?: FileAnswersJson;

	/**
	 * @generated from field: forms.v1.NumericAnswer numeric_answer = 4;
	 */
	numericAnswer?: NumericAnswerJson;
};

/**
 * Describes the message forms.v1.Answer.
 * Use `create(AnswerSchema)` to create a new message.
 */
export const AnswerSchema: GenMessage<Answer, { jsonType: AnswerJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 6);

/**
 * @generated from message forms.v1.PostDataResponse
 */
export type PostDataResponse = Message<"forms.v1.PostDataResponse"> & {
	/**
	 * @generated from field: string form_id = 3;
	 */
	formId: string;

	/**
	 * @generated from field: forms.v1.Submission submission = 1;
	 */
	submission?: Submission | undefined;

	/**
	 * @generated from field: forms.v1.SuccessAction success_action = 2;
	 */
	successAction?: SuccessAction | undefined;
};

/**
 * @generated from message forms.v1.PostDataResponse
 */
export type PostDataResponseJson = {
	/**
	 * @generated from field: string form_id = 3;
	 */
	formId?: string;

	/**
	 * @generated from field: forms.v1.Submission submission = 1;
	 */
	submission?: SubmissionJson;

	/**
	 * @generated from field: forms.v1.SuccessAction success_action = 2;
	 */
	successAction?: SuccessActionJson;
};

/**
 * Describes the message forms.v1.PostDataResponse.
 * Use `create(PostDataResponseSchema)` to create a new message.
 */
export const PostDataResponseSchema: GenMessage<PostDataResponse, { jsonType: PostDataResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 7);

/**
 * @generated from message forms.v1.Submission
 */
export type Submission = Message<"forms.v1.Submission"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: repeated forms.v1.FieldValue fields = 2;
	 */
	fields: FieldValue[];
};

/**
 * @generated from message forms.v1.Submission
 */
export type SubmissionJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: repeated forms.v1.FieldValue fields = 2;
	 */
	fields?: FieldValueJson[];
};

/**
 * Describes the message forms.v1.Submission.
 * Use `create(SubmissionSchema)` to create a new message.
 */
export const SubmissionSchema: GenMessage<Submission, { jsonType: SubmissionJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 8);

/**
 * @generated from message forms.v1.FieldValue
 */
export type FieldValue = Message<"forms.v1.FieldValue"> & {
	/**
	 * @generated from field: forms.v1.Field field = 1;
	 */
	field?: Field | undefined;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: Value | undefined;
};

/**
 * @generated from message forms.v1.FieldValue
 */
export type FieldValueJson = {
	/**
	 * @generated from field: forms.v1.Field field = 1;
	 */
	field?: FieldJson;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: ValueJson;
};

/**
 * Describes the message forms.v1.FieldValue.
 * Use `create(FieldValueSchema)` to create a new message.
 */
export const FieldValueSchema: GenMessage<FieldValue, { jsonType: FieldValueJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 9);

/**
 * Proto stored in the db
 *
 * @generated from message forms.v1.DBAnswers
 */
export type DBAnswers = Message<"forms.v1.DBAnswers"> & {
	/**
	 * @generated from field: map<string, forms.v1.Answer> answers = 1;
	 */
	answers: { [key: string]: Answer };
};

/**
 * Proto stored in the db
 *
 * @generated from message forms.v1.DBAnswers
 */
export type DBAnswersJson = {
	/**
	 * @generated from field: map<string, forms.v1.Answer> answers = 1;
	 */
	answers?: { [key: string]: AnswerJson };
};

/**
 * Describes the message forms.v1.DBAnswers.
 * Use `create(DBAnswersSchema)` to create a new message.
 */
export const DBAnswersSchema: GenMessage<DBAnswers, { jsonType: DBAnswersJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 10);

/**
 * @generated from message forms.v1.FormSummary
 */
export type FormSummary = Message<"forms.v1.FormSummary"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;

	/**
	 * @generated from field: string title = 2;
	 */
	title: string;

	/**
	 * @generated from field: int64 submission_count = 3;
	 */
	submissionCount: bigint;
};

/**
 * @generated from message forms.v1.FormSummary
 */
export type FormSummaryJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;

	/**
	 * @generated from field: string title = 2;
	 */
	title?: string;

	/**
	 * @generated from field: int64 submission_count = 3;
	 */
	submissionCount?: string;
};

/**
 * Describes the message forms.v1.FormSummary.
 * Use `create(FormSummarySchema)` to create a new message.
 */
export const FormSummarySchema: GenMessage<FormSummary, { jsonType: FormSummaryJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 11);

/**
 * @generated from message forms.v1.SubmitFormRequest
 */
export type SubmitFormRequest = Message<"forms.v1.SubmitFormRequest"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;

	/**
	 * @generated from field: map<string, forms.v1.Answer> answers = 2;
	 */
	answers: { [key: string]: Answer };
};

/**
 * @generated from message forms.v1.SubmitFormRequest
 */
export type SubmitFormRequestJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;

	/**
	 * @generated from field: map<string, forms.v1.Answer> answers = 2;
	 */
	answers?: { [key: string]: AnswerJson };
};

/**
 * Describes the message forms.v1.SubmitFormRequest.
 * Use `create(SubmitFormRequestSchema)` to create a new message.
 */
export const SubmitFormRequestSchema: GenMessage<SubmitFormRequest, { jsonType: SubmitFormRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 12);

/**
 * @generated from message forms.v1.SubmitFormResponse
 */
export type SubmitFormResponse = Message<"forms.v1.SubmitFormResponse"> & {};

/**
 * @generated from message forms.v1.SubmitFormResponse
 */
export type SubmitFormResponseJson = {};

/**
 * Describes the message forms.v1.SubmitFormResponse.
 * Use `create(SubmitFormResponseSchema)` to create a new message.
 */
export const SubmitFormResponseSchema: GenMessage<SubmitFormResponse, { jsonType: SubmitFormResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 13);

/**
 * @generated from message forms.v1.SubmissionRow
 */
export type SubmissionRow = Message<"forms.v1.SubmissionRow"> & {
	/**
	 * @generated from field: map<string, forms.v1.Answer> answers = 1;
	 */
	answers: { [key: string]: Answer };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 2;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: string id = 3;
	 */
	id: string;
};

/**
 * @generated from message forms.v1.SubmissionRow
 */
export type SubmissionRowJson = {
	/**
	 * @generated from field: map<string, forms.v1.Answer> answers = 1;
	 */
	answers?: { [key: string]: AnswerJson };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 2;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: string id = 3;
	 */
	id?: string;
};

/**
 * Describes the message forms.v1.SubmissionRow.
 * Use `create(SubmissionRowSchema)` to create a new message.
 */
export const SubmissionRowSchema: GenMessage<SubmissionRow, { jsonType: SubmissionRowJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 14);

/**
 * @generated from message forms.v1.ListSubmissionsRequest
 */
export type ListSubmissionsRequest = Message<"forms.v1.ListSubmissionsRequest"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;

	/**
	 * @generated from field: optional string filter = 2;
	 */
	filter?: string | undefined;

	/**
	 * @generated from field: optional forms.v1.PaginationOptions page_options = 3;
	 */
	pageOptions?: PaginationOptions | undefined;

	/**
	 * @generated from field: optional forms.v1.DateRange date_range = 4;
	 */
	dateRange?: DateRange | undefined;
};

/**
 * @generated from message forms.v1.ListSubmissionsRequest
 */
export type ListSubmissionsRequestJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;

	/**
	 * @generated from field: optional string filter = 2;
	 */
	filter?: string;

	/**
	 * @generated from field: optional forms.v1.PaginationOptions page_options = 3;
	 */
	pageOptions?: PaginationOptionsJson;

	/**
	 * @generated from field: optional forms.v1.DateRange date_range = 4;
	 */
	dateRange?: DateRangeJson;
};

/**
 * Describes the message forms.v1.ListSubmissionsRequest.
 * Use `create(ListSubmissionsRequestSchema)` to create a new message.
 */
export const ListSubmissionsRequestSchema: GenMessage<ListSubmissionsRequest, { jsonType: ListSubmissionsRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 15);

/**
 * @generated from message forms.v1.ListSubmissionsResponse
 */
export type ListSubmissionsResponse = Message<"forms.v1.ListSubmissionsResponse"> & {
	/**
	 * @generated from field: repeated forms.v1.SubmissionRow submissions = 1;
	 */
	submissions: SubmissionRow[];

	/**
	 * @generated from field: string next_page_token = 2;
	 */
	nextPageToken: string;
};

/**
 * @generated from message forms.v1.ListSubmissionsResponse
 */
export type ListSubmissionsResponseJson = {
	/**
	 * @generated from field: repeated forms.v1.SubmissionRow submissions = 1;
	 */
	submissions?: SubmissionRowJson[];

	/**
	 * @generated from field: string next_page_token = 2;
	 */
	nextPageToken?: string;
};

/**
 * Describes the message forms.v1.ListSubmissionsResponse.
 * Use `create(ListSubmissionsResponseSchema)` to create a new message.
 */
export const ListSubmissionsResponseSchema: GenMessage<ListSubmissionsResponse, { jsonType: ListSubmissionsResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 16);

/**
 * @generated from message forms.v1.DeleteSubmissionRequest
 */
export type DeleteSubmissionRequest = Message<"forms.v1.DeleteSubmissionRequest"> & {
	/**
	 * @generated from field: string submission_id = 1;
	 */
	submissionId: string;
};

/**
 * @generated from message forms.v1.DeleteSubmissionRequest
 */
export type DeleteSubmissionRequestJson = {
	/**
	 * @generated from field: string submission_id = 1;
	 */
	submissionId?: string;
};

/**
 * Describes the message forms.v1.DeleteSubmissionRequest.
 * Use `create(DeleteSubmissionRequestSchema)` to create a new message.
 */
export const DeleteSubmissionRequestSchema: GenMessage<DeleteSubmissionRequest, { jsonType: DeleteSubmissionRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 17);

/**
 * @generated from message forms.v1.DeleteSubmissionResponse
 */
export type DeleteSubmissionResponse = Message<"forms.v1.DeleteSubmissionResponse"> & {};

/**
 * @generated from message forms.v1.DeleteSubmissionResponse
 */
export type DeleteSubmissionResponseJson = {};

/**
 * Describes the message forms.v1.DeleteSubmissionResponse.
 * Use `create(DeleteSubmissionResponseSchema)` to create a new message.
 */
export const DeleteSubmissionResponseSchema: GenMessage<DeleteSubmissionResponse, { jsonType: DeleteSubmissionResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 18);

/**
 * @generated from message forms.v1.BatchDeleteSubmissionRequest
 */
export type BatchDeleteSubmissionRequest = Message<"forms.v1.BatchDeleteSubmissionRequest"> & {
	/**
	 * @generated from field: repeated string submission_ids = 1;
	 */
	submissionIds: string[];
};

/**
 * @generated from message forms.v1.BatchDeleteSubmissionRequest
 */
export type BatchDeleteSubmissionRequestJson = {
	/**
	 * @generated from field: repeated string submission_ids = 1;
	 */
	submissionIds?: string[];
};

/**
 * Describes the message forms.v1.BatchDeleteSubmissionRequest.
 * Use `create(BatchDeleteSubmissionRequestSchema)` to create a new message.
 */
export const BatchDeleteSubmissionRequestSchema: GenMessage<BatchDeleteSubmissionRequest, { jsonType: BatchDeleteSubmissionRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 19);

/**
 * @generated from message forms.v1.BatchDeleteSubmissionResponse
 */
export type BatchDeleteSubmissionResponse = Message<"forms.v1.BatchDeleteSubmissionResponse"> & {};

/**
 * @generated from message forms.v1.BatchDeleteSubmissionResponse
 */
export type BatchDeleteSubmissionResponseJson = {};

/**
 * Describes the message forms.v1.BatchDeleteSubmissionResponse.
 * Use `create(BatchDeleteSubmissionResponseSchema)` to create a new message.
 */
export const BatchDeleteSubmissionResponseSchema: GenMessage<BatchDeleteSubmissionResponse, { jsonType: BatchDeleteSubmissionResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 20);

/**
 * @generated from message forms.v1.SubmissionsSummaryRequest
 */
export type SubmissionsSummaryRequest = Message<"forms.v1.SubmissionsSummaryRequest"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;

	/**
	 * @generated from field: optional string filter = 2;
	 */
	filter?: string | undefined;

	/**
	 * @generated from field: optional forms.v1.DateRange date_range = 3;
	 */
	dateRange?: DateRange | undefined;
};

/**
 * @generated from message forms.v1.SubmissionsSummaryRequest
 */
export type SubmissionsSummaryRequestJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;

	/**
	 * @generated from field: optional string filter = 2;
	 */
	filter?: string;

	/**
	 * @generated from field: optional forms.v1.DateRange date_range = 3;
	 */
	dateRange?: DateRangeJson;
};

/**
 * Describes the message forms.v1.SubmissionsSummaryRequest.
 * Use `create(SubmissionsSummaryRequestSchema)` to create a new message.
 */
export const SubmissionsSummaryRequestSchema: GenMessage<SubmissionsSummaryRequest, { jsonType: SubmissionsSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 21);

/**
 * @generated from message forms.v1.SubmissionsSummaryResponse
 */
export type SubmissionsSummaryResponse = Message<"forms.v1.SubmissionsSummaryResponse"> & {
	/**
	 * @generated from field: int64 total_count = 1;
	 */
	totalCount: bigint;
};

/**
 * @generated from message forms.v1.SubmissionsSummaryResponse
 */
export type SubmissionsSummaryResponseJson = {
	/**
	 * @generated from field: int64 total_count = 1;
	 */
	totalCount?: string;
};

/**
 * Describes the message forms.v1.SubmissionsSummaryResponse.
 * Use `create(SubmissionsSummaryResponseSchema)` to create a new message.
 */
export const SubmissionsSummaryResponseSchema: GenMessage<SubmissionsSummaryResponse, { jsonType: SubmissionsSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 22);

/**
 * @generated from message forms.v1.DownloadSubmissionsCSVRequest
 */
export type DownloadSubmissionsCSVRequest = Message<"forms.v1.DownloadSubmissionsCSVRequest"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;
};

/**
 * @generated from message forms.v1.DownloadSubmissionsCSVRequest
 */
export type DownloadSubmissionsCSVRequestJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;
};

/**
 * Describes the message forms.v1.DownloadSubmissionsCSVRequest.
 * Use `create(DownloadSubmissionsCSVRequestSchema)` to create a new message.
 */
export const DownloadSubmissionsCSVRequestSchema: GenMessage<DownloadSubmissionsCSVRequest, { jsonType: DownloadSubmissionsCSVRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 23);

/**
 * @generated from message forms.v1.GetLiveResultsRequest
 */
export type GetLiveResultsRequest = Message<"forms.v1.GetLiveResultsRequest"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;
};

/**
 * @generated from message forms.v1.GetLiveResultsRequest
 */
export type GetLiveResultsRequestJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;
};

/**
 * Describes the message forms.v1.GetLiveResultsRequest.
 * Use `create(GetLiveResultsRequestSchema)` to create a new message.
 */
export const GetLiveResultsRequestSchema: GenMessage<GetLiveResultsRequest, { jsonType: GetLiveResultsRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 24);

/**
 * @generated from message forms.v1.Count
 */
export type Count = Message<"forms.v1.Count"> & {
	/**
	 * @generated from field: map<string, string> field_counts = 1;
	 */
	fieldCounts: { [key: string]: string };
};

/**
 * @generated from message forms.v1.Count
 */
export type CountJson = {
	/**
	 * @generated from field: map<string, string> field_counts = 1;
	 */
	fieldCounts?: { [key: string]: string };
};

/**
 * Describes the message forms.v1.Count.
 * Use `create(CountSchema)` to create a new message.
 */
export const CountSchema: GenMessage<Count, { jsonType: CountJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 25);

/**
 * @generated from message forms.v1.GetLiveResultsResponse
 */
export type GetLiveResultsResponse = Message<"forms.v1.GetLiveResultsResponse"> & {
	/**
	 * @generated from field: map<string, forms.v1.Count> counts = 1;
	 */
	counts: { [key: string]: Count };
};

/**
 * @generated from message forms.v1.GetLiveResultsResponse
 */
export type GetLiveResultsResponseJson = {
	/**
	 * @generated from field: map<string, forms.v1.Count> counts = 1;
	 */
	counts?: { [key: string]: CountJson };
};

/**
 * Describes the message forms.v1.GetLiveResultsResponse.
 * Use `create(GetLiveResultsResponseSchema)` to create a new message.
 */
export const GetLiveResultsResponseSchema: GenMessage<GetLiveResultsResponse, { jsonType: GetLiveResultsResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 26);

/**
 * @generated from message forms.v1.BatchGetSubmissionSummariesRequest
 */
export type BatchGetSubmissionSummariesRequest = Message<"forms.v1.BatchGetSubmissionSummariesRequest"> & {
	/**
	 * @generated from field: repeated string form_ids = 1;
	 */
	formIds: string[];

	/**
	 * @generated from field: bool all_forms = 2;
	 */
	allForms: boolean;
};

/**
 * @generated from message forms.v1.BatchGetSubmissionSummariesRequest
 */
export type BatchGetSubmissionSummariesRequestJson = {
	/**
	 * @generated from field: repeated string form_ids = 1;
	 */
	formIds?: string[];

	/**
	 * @generated from field: bool all_forms = 2;
	 */
	allForms?: boolean;
};

/**
 * Describes the message forms.v1.BatchGetSubmissionSummariesRequest.
 * Use `create(BatchGetSubmissionSummariesRequestSchema)` to create a new message.
 */
export const BatchGetSubmissionSummariesRequestSchema: GenMessage<BatchGetSubmissionSummariesRequest, { jsonType: BatchGetSubmissionSummariesRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 27);

/**
 * @generated from message forms.v1.BatchGetSubmissionSummariesResponse
 */
export type BatchGetSubmissionSummariesResponse = Message<"forms.v1.BatchGetSubmissionSummariesResponse"> & {
	/**
	 * @generated from field: repeated forms.v1.FormSummary statistics = 1;
	 */
	statistics: FormSummary[];
};

/**
 * @generated from message forms.v1.BatchGetSubmissionSummariesResponse
 */
export type BatchGetSubmissionSummariesResponseJson = {
	/**
	 * @generated from field: repeated forms.v1.FormSummary statistics = 1;
	 */
	statistics?: FormSummaryJson[];
};

/**
 * Describes the message forms.v1.BatchGetSubmissionSummariesResponse.
 * Use `create(BatchGetSubmissionSummariesResponseSchema)` to create a new message.
 */
export const BatchGetSubmissionSummariesResponseSchema: GenMessage<BatchGetSubmissionSummariesResponse, { jsonType: BatchGetSubmissionSummariesResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_form_submission, 28);
